import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface usePublicationsProps {
  id: string;
  beat_id: string;
}

export function usePublications({ id, beat_id }: usePublicationsProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: `influencer-collaboration-${id}-${beat_id}-publications`,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/collaboration/${id}/publications?beat_id=${beat_id}`,
        token
      }).then((response: { publications: Api.Influencer.Publication[] } | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      })
    // enabled: !!token && enabled
  });

  return {
    error,
    isLoading,
    publications: (data?.publications as Api.Influencer.Publication[]) || [] || {},
    refetch
  };
}
